<app-header>
  <a routerLink="/goals">
    <img src="../../../../assets/images/icons/chevron-left.svg" alt="back" />
  </a>
  @if (!loading) {
    <span>{{ !goal.goalId ? 'New' : '' }}Goal</span>
  }
  @if (!loading) {
    <div class="actions">
      <app-button type="primary" [loading]="saving" (click)="trySave()" iconUrl="../../../../assets/images/icons/save.svg"> Save </app-button>
      <app-button type="warning" (click)="goBack()" matTooltip="Go back without saving" iconUrl="../../../../assets/images/icons/cancel.svg">
        Cancel
      </app-button>
    </div>
  }
</app-header>
<div class="form">
  @if (!loading) {
    <div class="flex-row">
      <app-select
        size="small"
        label="Parent Skill"
        [(value)]="goal.skillId"
        [options]="availableSkills"
        (valueChange)="onSkillChange($event)"
      ></app-select>
      <app-select size="small" [(value)]="goal.order" [options]="availableOrders" label="Order in Parent Skill"></app-select>
    </div>
    <div class="flex-row">
      <div class="column">
        <app-textfield
          label="Goal title"
          [(value)]="goal.title"
          [error]="emptyMandatoryFields.includes('title') ? 'This field is required.' : ''"
        ></app-textfield>
        <app-textfield label="Goal secondary title (optional)" [(value)]="goal.subtitle"></app-textfield>
        <app-richtextarea label="Goal description" placeholder="Place your text" [(value)]="goal.description"></app-richtextarea>
        <app-tagfield label="Tags" [(values)]="goal.tags"></app-tagfield>
      </div>
      <div class="column">
        <div class="thumb-preview">
          @if (goal.videoLink) {
            <video [src]="goal.videoLink" controls></video>
          } @else {
            <img src="../../../../assets/images/icons/video-placeholder.svg" />
          }
        </div>
        <app-file-picker
          id="video"
          type="video"
          [value]="goal.videoLink"
          label="Britt's tips video"
          (fileChange)="goal.videoFile = $event; !$event && (goal.videoLink = '')"
        ></app-file-picker>
        <app-file-picker
          id="image"
          type="image"
          [value]="goal.videoThumbnail"
          label="Britt's Tips Video Thumbnail"
          (fileChange)="goal.videoThumbnailFile = $event; !$event && (goal.videoThumbnail = '')"
          [error]="emptyMandatoryFields.includes('videoThumbnail') ? 'This field is required.' : ''"
        ></app-file-picker>
        <div class="thumb-picker">
          <img [src]="goal.icon || '../../../../assets/images/icons/image-placeholder.svg'" />
          <app-file-picker
            id="icon"
            type="image"
            size="small"
            label="Goal icon"
            [value]="goal.icon"
            (fileChange)="goal.iconFile = $event; !$event && (goal.icon = '')"
          ></app-file-picker>
        </div>
      </div>
    </div>
    <div class="flex-row units-section">
      <app-associated-units-list
        [unitsGroupedByAge]="unitsWithThisGoalId"
        [parentEntityName]="'Goal'"
        (unitsChanged)="onUnitsChanged($event)"
        (hasUnsavedChanges)="hasUnsavedUnitChanges = $event"
      ></app-associated-units-list>
    </div>
    <div class="flex-row">
      <app-named-file-list
        [values]="goal.downloads"
        entityName="Visual Support"
        [errors]="emptyMandatoryFields"
        (valuesChange)="goal.downloads = $event"
      ></app-named-file-list>
    </div>
    <div class="flex-row learning-standards-section">
      <div class="learning-standards-container">
        <h2>Learning Standards</h2>

        @for (ageGroup of selStandardsAgeGroups; track ageGroup.key) {
          <div class="learning-standards-age-group">
            <p class="age-group-label">{{ ageGroup.label }}</p>
            <p class="helper-text">Goals (one per line)</p>
            <textarea placeholder="Goals (one per line)" [(ngModel)]="selStandardsDisplay[ageGroup.key].selGoals" rows="3"></textarea>
            <p class="helper-text">Learning Standards (one per line)</p>
            <textarea
              placeholder="Learning Standards (one per line)"
              [(ngModel)]="selStandardsDisplay[ageGroup.key].learningStandards"
              rows="3"
            ></textarea>
            <p class="helper-text">Standardized Benchmarks (one per line)</p>
            <textarea
              placeholder="Standardized Benchmarks (one per line)"
              [(ngModel)]="selStandardsDisplay[ageGroup.key].standardizedBenchmarks"
              rows="3"
            ></textarea>
          </div>
        }
      </div>
    </div>
    <div class="flex-row sample-iep-goals-section">
      <app-sample-iep-goals
        [goals]="goal.selStandards!.sampleIepGoals"
        (goalsChange)="goal.selStandards!.sampleIepGoals = $event"
      ></app-sample-iep-goals>
    </div>
    @if (goal.goalId) {
      <div class="dangerous-area">
        <app-button type="danger" [loading]="deleting" (click)="confirmDelete()" iconUrl="../../../../assets/images/icons/delete.svg">
          Delete
        </app-button>
        <div>Warning: Deleting a goal will REMOVE related units from the Full Curriculum page</div>
      </div>
    }
  }
  @if (loading) {
    <app-loader></app-loader>
  }
</div>
